<template>
  <div :is="tag" role="table" :class="['bcq-table-layout', borderCollapse ? 'bcq-table-layout-collapse' : null, fullHeight ? 'bcq-table-layout-full-height' : null, equalCells ? 'bcq-table-layout-fixed' : null, `bcq-table-layout-v-align-${yAlign}`, `bcq-table-layout-x-align-${xAlign}`]">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'TableLayout',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    fullHeight: {
      type: Boolean
    },
    equalCells: {
      type: Boolean
    },
    yAlign: {
      type: String,
      default: 'top',
      validator: value => {
        return ['top', 'middle', 'bottom', 'baseline', 'auto'].includes(value)
      }
    },
    xAlign: {
      type: String,
      default: 'left',
      validator: value => {
        return ['left', 'center', 'right', 'auto', 'justify'].includes(value)
      }
    },
    borderCollapse: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style>
.bcq-table-layout
{
  display: table;
  width: 100%;
}

.bcq-table-layout-collapse
{
  border-collapse: collapse;
}

.bcq-table-layout > *
{
  display: table-row;
}

.bcq-table-layout > * > *
{
  display: table-cell;
}

.bcq-table-layout.bcq-table-layout-fixed
{
  table-layout: fixed;
}

.bcq-table-layout-full-height
{
  height: 100vh;
}

.bcq-table-layout-cell-x-align-left,
.bcq-table-layout-x-align-left > * > *
{
  text-align: left;
}

.bcq-table-layout-cell-x-align-center,
.bcq-table-layout-x-align-center > * > *
{
  text-align: center;
}

.bcq-table-layout-cell-x-align-right,
.bcq-table-layout-x-align-right > * > *
{
  text-align: right;
}

.bcq-table-layout-cell-v-align-top,
.bcq-table-layout-v-align-top > * > *
{
  vertical-align: top;
}

.bcq-table-layout-cell-v-align-middle,
.bcq-table-layout-v-align-middle > * > *
{
  vertical-align: middle;
}

.bcq-table-layout-cell-v-align-bottom,
.bcq-table-layout-v-align-bottom > * > *
{
  vertical-align: bottom;
}

.bcq-table-layout-cell-v-align-baseline,
.bcq-table-layout-v-align-baseline > * > *
{
  vertical-align: baseline;
}

.bcq-table-layout-cell-full-width
{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/table-layout/table-layout.vue